module.exports = __webpack_public_path__ + "static/media/PV_OFF.4127ca2d.svg";